import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-variant-type',
  templateUrl: './header-column-variant-type.component.html',
  styleUrls: ['./header-column-variant-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnVariantTypeComponent extends HeaderColumnComponent {}
